import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { PERMISSION_SUPPLIER } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import SuppliersForm from '../../components/OperationCosts/Suppliers/SuppliersForm';
import { URL_SUPPLIERS } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/suppliers/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_SUPPLIER, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.suppliersOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddSupplierRoute,
});

function AddSupplierRoute() {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate({ to: URL_SUPPLIERS });
  }, [navigate]);

  return <SuppliersForm isEdited={false} closeCallback={handleClose} selectedId={null} />;
}
